import { LeanFormSchema, fieldRef } from '../types/config-form.types';
import { V3PurchasePowerLimitSettings } from 'ngx-modbus';

export const PURCHASE_POWER_LIMIT_FORM: LeanFormSchema = {
  version: '2.0.0',
  id: 'purchase-power-limit-settings',
  name: 'Purchase Power Limit Settings',
  sections: [{
    id: 'purchase-power-limit',
    labelKey: 'purchasePowerLimitSettings',
    registerTable: 'V3PurchasePowerLimitSettings',
    fields: [
      fieldRef(V3PurchasePowerLimitSettings, 'Purchase_Total_Power_Limit_Enable', {
        labelKey: 'purchasePowerLimitControl',
      }),
      fieldRef(V3PurchasePowerLimitSettings, 'Purchase_Total_Power_Limit_Value', {
        labelKey: 'purchasePowerLimitValue',
      }),
    ],
  }],
};
